import React from 'react'
import './RetroToggle.css'
import { useRetroMode } from '../../context/RetroModeContext'
import { trackEvent } from '../../lib/analytics'

const RetroToggle = () => {
  const { retroMode, toggleRetroMode } = useRetroMode()

  const handleClick = () => {
    trackEvent('retro_mode_toggle', { enabled: !retroMode })
    toggleRetroMode()
  }

  return (
    <button
      type="button"
      className="retro-toggle"
      onClick={handleClick}
      aria-pressed={retroMode}
    >
      <span role="img" aria-hidden="true">
        {retroMode ? '🖥️' : '💾'}
      </span>
      {retroMode ? 'Voltar ao site normal' : 'Modo Anos 2000'}
    </button>
  )
}

export default RetroToggle
